import { createContext, useCallback, useContext, useEffect, useState } from "react";
import el from "./el.json";
import en from "./en.json";
import elX from "./el.x.json";
import enX from "./en.x.json";

const merge = (a, b) => {
  const out = { ...a };
  Object.entries(b).forEach(([k, v]) => { out[k] = v && typeof v === "object" && !Array.isArray(v) && a[k] ? merge(a[k], v) : v; });
  return out;
};
const DICTS = { el: merge(el, elX), en: merge(en, enX) };
const STORAGE_KEY = "vavlis.lang";
const I18nContext = createContext(null);

const lookup = (dict, key) => key.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "el");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (next) => {
    localStorage.setItem(STORAGE_KEY, next);
    setLangState(next);
  };

  const t = useCallback(
    (key, vars) => {
      const value = lookup(DICTS[lang], key) ?? lookup(DICTS.el, key) ?? key;
      if (!vars || typeof value !== "string") return value;
      const one = vars.n === 1 ? (lookup(DICTS[lang], `${key}One`) ?? lookup(DICTS.el, `${key}One`)) : null;
      return (typeof one === "string" ? one : value).replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? ""));
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
